export default class TasksController {
    /* @ngInject */
    constructor($scope, $rootScope, $state, $ionicLoading, ApiUser, $ionicPopup, $filter, $stateParams, $ionicScrollDelegate) {
        this.ApiUser = ApiUser;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.defaultTab = $stateParams.defaultTab;
        this.filterIsActive = true;
        this.filterButtonClass = '';
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    init() {

        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
        let currentUser = this.$rootScope.user;

        if (!currentUser) {
            this.ApiUser.getUser().then((res) => {
                if (angular.isDefined(res)) {
                    this.taskParameters = { currentUserId: res.id };
                    this.$ionicLoading.hide();
                }
            });
        } else {
            this.taskParameters = { currentUserId: currentUser.id };
            this.$ionicLoading.hide();
        }
    }


    popUp($event, itemType) {
        let title = itemType === 'TASK' ? 'DELETE_TASKS' : 'DELETE_ACTIVITIES';
        let content = itemType === 'TASK' ? 'DELETE_TASKS_PROMPT' : 'DELETE_ACTIVITIES_PROMPT';

        $event.preventDefault();
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')(title),
            template: this.$filter('translate')(content)
        });

        dialogResult.then((res) => {
            if (res) {
                this.showCheckboxes = !this.showCheckboxes;
                if (itemType === 'TASK') {
                    this.deleteTasks();
                } else {
                    this.deleteActivities();
                }
            }
        });
    }

    setCurrentTab(tabName) {
        this.taskType = tabName || 'TASK';
        sessionStorage.setItem('task-tab', tabName);
        this.$ionicScrollDelegate.scrollTop();
    }

    displayTab() {
        let currentTab = sessionStorage.getItem('task-tab') || 'TASK';
        this.taskType = currentTab;
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/tasks.controller.js
 **/